/**
 * @file 获取未读弹窗
 * @author liudaoyu
 * {@link https://docs.google.com/document/d/1igztR_t52T1XNtWUNpS45AxFTV6peg6uOP8vx0dgJFU/edit#heading=h.24pxor2qg4wm}
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

import { AchivementDialogType } from '@umu/umu-types';

// tslint:disable-next-line:no-empty-interface
export interface IDialogDataItem {}

export interface IDailyLogin extends IDialogDataItem {
    active_days: number;
    growth_points: string;
    show_login_achievement: number;
}

export interface IUserLevel extends IDialogDataItem {
    user_level: number;
    privilege: string;
    privilege_tips: string;
}

export interface IUserMedal extends IDialogDataItem {
    id: string;
    medal_title: string;
    medal_remark: string;
    growth_points: number;
    action_num: number;
    action_name: string;
    medal_type: string;
    medal_rank: string;
}
interface IParams {
    enterprise_id?: string;
}
// export type IDialogDataItem = IDailyLogin | IUserLevel | IUserMedal;

export interface IDialogData {
    type: AchivementDialogType;
    data: IDialogDataItem[];
}

export type IGetUnreadDialogsOutput = IDialogData[];

export const getUnreadDialogs = (param: IParams): Promise<IGetUnreadDialogsOutput> => {
    return fetchData(Api.ACHIEVEMENT_GET_UNREAD_DIALOGS, param, {
        silent: true,
    }).then((res: IResponse<IGetUnreadDialogsOutput>) => {
        return (res.data || []) as IGetUnreadDialogsOutput;
    });
};
